import { useContext } from "react";
import { KycContext } from "../contexts/KycContext";

export const useKyc = () => useContext(KycContext);
